module.exports = __webpack_public_path__ + "img/logo.0d8e6f28.gif";